import React from "react";

const ResumeSummaryPopup = ({ candidate, onClose }) => {
    if (!candidate) return null;
    return (
        <div className="upload-modal">
            <div className="modal-content" style={{ width: "600px", height: "auto" }}>
                <div className="modal-head">
                    <h3>Summary</h3>
                    <img
                        src="/images/close-icon.svg"
                        alt="Close"
                        style={{ cursor: "pointer" }}
                        onClick={onClose}
                    />
                </div>
                <div
                    className="modal-input"
                    style={{
                        height: "220px",
                        width: "auto",
                        overflow: "auto",
                        justifyContent: "unset",
                    }}
                >
                    <p>{candidate.profile_summary || "No summary available."}</p>
                </div>
                <div className="d-flex justify-content-center">
                    <button className="upload-btn" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ResumeSummaryPopup;
